module.exports = __webpack_public_path__ + "img/chaintraced-logo.86641ae1.png";